<template>
  <div class="distribution-staus">
    <span :class="typeName().className" />
    {{ typeName().name }}
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: () => 'Unknown',
    },
  },
  methods: {
    typeName() {
      const statusColor = [
        { id: 0, value: 'Unknown' },
        { id: 1, value: 'Deployed', className: 'Deployed' },
        { id: 2, value: 'Deploying', className: 'Deploying' },
        { id: 3, value: 'Failed', className: 'Failed' },
      ]
      const status = statusColor.find(item => item.value === this.type)

      if (status) {
        return status
      }
      return { id: 0, value: 'Unknown', className: '' }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/../GjirafaFront/style/theme.scss";
.distribution-staus {
  display: flex;
  align-items: center;

  span {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin-right: 4px;
    margin-top: 1px;
    background-color: $gray;

    &.Deployed {
      background-color: $green;
    }
    &.Deploying {
      background-color: $orange;
    }
    &.Failed {
      background-color: $red;
    }
  }
}
</style>
